type ButtonDef = {
    text?: string;
    title?: string;
};

type IconButtonDef = {
    title: string;
};

export type MprcLocaleType = {
    buttons: {
        ButtonAdd: ButtonDef;
        ButtonApply: ButtonDef;
        ButtonApplyFilter: ButtonDef;
        ButtonBack: ButtonDef;
        ButtonCancel: ButtonDef;
        ButtonClose: ButtonDef;
        ButtonClear: ButtonDef;
        ButtonConfirm: ButtonDef;
        ButtonConfirmAndClose: ButtonDef;
        ButtonContinue: ButtonDef;
        ButtonCopyToClipboard: ButtonDef;
        ButtonDiscard: ButtonDef;
        ButtonDelete: ButtonDef;
        ButtonEdit: ButtonDef;
        ButtonEllipsis: ButtonDef;
        ButtonError: ButtonDef;
        ButtonExport: ButtonDef;
        ButtonFinish: ButtonDef;
        ButtonJoin: ButtonDef;
        ButtonResetFilter: ButtonDef;
        ButtonOk: ButtonDef;
        ButtonOrderBy: ButtonDef;
        ButtonOverflowV: ButtonDef;
        ButtonPrint: ButtonDef;
        ButtonPublish: ButtonDef;
        ButtonSave: ButtonDef;
        ButtonSelect: ButtonDef;
        ButtonSend: ButtonDef;
        ButtonRefresh: ButtonDef;
        ButtonRetry: ButtonDef;
        ButtonNextStep: ButtonDef;
        ButtonPreviousStep: ButtonDef;
    };

    iconButtons: {
        IconButtonAdd: IconButtonDef;
        IconButtonAI: IconButtonDef;
        IconButtonBack: IconButtonDef;
        IconButtonCancel: IconButtonDef;
        IconButtonClearSearch: IconButtonDef;
        IconButtonClose: IconButtonDef;
        IconButtonCog: IconButtonDef;
        IconButtonDelete: IconButtonDef;
        IconButtonEdit: IconButtonDef;
        IconButtonExcel: IconButtonDef;
        IconButtonFilter: IconButtonDef;
        IconButtonExpandMembers: IconButtonDef;
        IconButtonOrderBy: IconButtonDef;
        IconButtonOverflowV: IconButtonDef;
        IconButtonOverflowW: IconButtonDef;
        IconButtonUndelete: IconButtonDef;
        IconButtonUpload: IconButtonDef;
        IconButtonCopy: IconButtonDef;
        IconButtonExportExcel: IconButtonDef;
        IconButtonBlocked: IconButtonDef;
        IconButtonGraph: IconButtonDef;
        IconButtonHierarchy: IconButtonDef;
        IconButtonOverflowH: IconButtonDef;
        IconButtonSave: IconButtonDef;
        IconButtonSearch: IconButtonDef;
        IconButtonHistory: IconButtonDef;
        IconButtonUndo: IconButtonDef;
        IconButtonFullScreen: IconButtonDef;
        IconButtonRestoreScreen: IconButtonDef;
        IconButtonViewDetails: IconButtonDef;
        IconButtonPreview: IconButtonDef;
        IconPublicationThread: IconButtonDef;
    };

    MprcAdvFilter: {
        loadMoreNum: string;
        emptyRecordset: string;
        emptyCommands: string;
        inputPlaceholder: string;
        inputPlaceholderFocus: string;
        inputTitleEnterToFilter: string;
        customPickerDialog: {
            inputPlaceholder: string;
        },
        textPickerSearchTypes: {
            equals: string;
            contains: string;
            startWith: string;
        },
        textPickerDrawer: {
            title: string;
            searchTextPlaceholder: string;
        },
        textPickerPopper: {
            label: string;
            placeholder: string;
        };
    },

    MprcFilterCount: {
        countTextSingular: string;
        countTextPlural: string;
        filteredTextSingular: string;
        filteredTextPlural: string;
        resetFilterText: string;

    },
    MprcFilterCountInfo: {
        textSingular: string;
        textPlural: string;
    },
    MprcFilterNoRecords: {
        noRecordsMessage: string;
        resetFilterText: string;
    },
    MprcConfirmation: {
        buttonNoText: string;
        buttonYesText: string;
    },
    MprcImageUpload: {
        selectText: string;
    };
    MprcAutoComplete: {
        loadMoreText: string;
        alternateMethodTitle: string;
        alreadySelectedText: string;
        suggestionEmptyListText: string;
        searchForPlaceholder: string;
        selectedItemsResult: string;
        displayingHistory: string;
        exitFromHistory: string;
    },
    MprcAutoComplete2: {
        loadMoreText: string;
        loadingText: string;
        noOptionsText: string;
    },
    MprcAutoCompleteHierarchical: {
        loadMoreText: string;
        loadingText: string;
        inputPlaceholder: string;
        lastSelectedText: string;
        grouperItemCannotSelected: string;
        itemCannotSelected: string;
        itemAlreadySelected: string;
        selectSingle: string;
        includeDescendants: string;
    },
    MprcAutoCompleteFreeText: {
        inputPlaceholder: string;
    };
    MprcTextFieldNumberMask: {
        invalidValueText: string,
        minValueText: string,
        maxValueText: string,
    },
    MprcKeyboardDatePicker: {
        okText: string;
        cancelText: string;
        clearText: string;
        todayText: string;
    },
    MprcFileSelection: {
        interrupted: string;
        uploadError: string;
        fileNotAccept: string;
        dropHereText1: string;
        dropHereText2: string;
        dropHereText3: string;
        maxSize: string;
        maxSizeError: string;
    },
    MprcImageSelection: {
        selectImageText: string;
        interrupted: string;
        uploadError: string;
        fileNotAccept: string;
        fileConversionError: string;
        cloudImageLoadError: string;
        cloudImageNotFound: string;
        dropHereText1: string;
        dropHereText2: string;
        dropHereText3: string;
        searchForLabel: string;
        searchImagePlaceholder: string;
        cropText: string;
        editTitle: string;
        editCropError: string;
        editImageLoadError: string;
        editImageFallbackSuccess: string;
        finalSize: string;
        resizeText: string;
        rotationText: string;
        originalSize: string;
    },
    MprcImageSelectionDialog: {
        dialogTitle: string;
        tabLibraryText: string;
        tabUploadImageText: string;
    },
    MprcAutoSelect: {
        noOptionsText: string;
    },
    MprcConfirmDialog: {
        message: string;
        yesText: string;
        noText: string;
    },
    MprcDialogConfirm: {
        yesText: string;
        noText: string;
    },
    MprcIconButtonMoreOptionsDropdown: {
        title: string;
    },
    MprcPrompt: {
        message: string;
        yesText: string;
        noText: string;
    },
    MprcRecordInfo: {
        createdBy: string;
        changedBy: string;
        deletedBy: string;
        historyText: string;
    },
    MprcQuillEditor: {
        customField: string;
        publication: string;
        image: string;
        video: string;
        link: string;
        bold: string;
        italic: string;
        underline: string;
        strike: string;
        identLeft: string;
        identRight: string;
        blockCode: string;
        blockQuote: string;
        clearFormat: string;
        fontSize: string;
        headerSize: string;
        textAlign: string;
        bgColor: string;
        textColor: string;
        orderedList: string;
        bulletList: string;
        mention: string;
        textDirection: string;
    },
    MprcUserProfileLink: {
        systemName: string;
        yourselfName: string;
    },
    MprcMultiLanguageInputDialog: {
        title: string;
        translateButton: string;
        errorMessage: string;
    },
    MprcPasteContainer: {
        transformError: string;
        pastedError: string;
    },
    MprcRibbonList:
    {
        expandTooltip: string;
        collapseTooltip: string;
        slideNextTooltip: string;
        slidePreviousTooltip: string;
        seeMoreText: string;
        searchPlaceholder: string;
        emptyDataText: string;
    },
    MprcDateTimePicker: {
        firstTimeOfDayText: string;
        endTimeOfDayText: string;
    },
    MprcTypographyOnDemand: {
        readMore: string;
        readLess: string;
    },
    MprcTimezoneSelect: {
        mapTooltip: string;
        mapDlgTitle: string;
        mapDlgDescription: string;
    },
    MprcInfoIconButton: {
        title: string;
    },
    MprcSearchTextField: {
        clearTooltip: string;
    },
    MprcReactPlayer: {
        speedButtomTitle: string;
        closeCaptionTitle: string;
        volumeTitle: string;
        mutedOffTitle: string;
        muteOnTitle: string;
        progressTitle: string;
        pauseTitle: string;
        playTitle: string;
        fullscreenInTitle: string;
        fullscreenOutTitle: string;
    };
};


export const ptBR: MprcLocaleType = {
    buttons: {
        ButtonAdd: {
            text: "Adicionar"
        },
        ButtonApply: {
            text: "Aplicar"
        },
        ButtonApplyFilter: {
            text: "Adicionar"
        },
        ButtonBack: {
            text: "Voltar"
        },
        ButtonCancel: {
            text: "Cancelar"
        },
        ButtonClose: {
            text: "Fechar"
        },
        ButtonClear: {
            text: "Limpar"
        },
        ButtonConfirm: {
            text: "Confirmar"
        },
        ButtonConfirmAndClose: {
            text: "Confirmar e Fechar"
        },
        ButtonContinue: {
            text: "Continuar"
        },
        ButtonCopyToClipboard: {
            text: "Copiar para Área de Transferência"
        },
        ButtonDelete: {
            text: "Excluir"
        },
        ButtonDiscard: {
            text: "Descartar"
        },
        ButtonEdit: {
            text: "Editar"
        },
        ButtonEllipsis: {
            title: "Mais opções"
        },
        ButtonError: {
            text: "Visualizar Erros",
            title: "Visualizar Erros"
        },
        ButtonExport: {
            text: "Exportar"
        },
        ButtonFinish: {
            text: "Finalizar"
        },
        ButtonOk: {
            text: "Ok"
        },
        ButtonOrderBy: {
            title: "Ordenação"
        },
        ButtonOverflowV: {
            title: "Mais opções"
        },
        ButtonPrint: {
            text: "Imprimir"
        },
        ButtonPublish: {
            text: "Publicar"
        },
        ButtonSave: {
            text: "Salvar"
        },
        ButtonSend: {
            text: "Enviar",
            title: "Enviar Informações"
        },
        ButtonSelect: {
            text: "Selecionar",
        },
        ButtonJoin: {
            text: "Juntar"
        },
        ButtonResetFilter: {
            text: "Limpar Filtro"
        },
        ButtonRefresh: {
            text: "Recarregar"
        },
        ButtonRetry: {
            text: "Tentar Novamente"
        },
        ButtonNextStep: {
            text: "Próximo Passo"
        },
        ButtonPreviousStep: {
            text: "Passo Anterior"
        }
    },
    iconButtons: {
        IconButtonAdd: {
            title: "Adicionar"
        },
        IconButtonAI: {
            title: "Criar com Inteligência Artificial"
        },
        IconButtonBack: {
            title: "Voltar"
        },
        IconButtonCancel: {
            title: "Cancelar"
        },
        IconButtonClearSearch: {
            title: "Limpar"
        },
        IconButtonClose: {
            title: "Fechar"
        },
        IconButtonCog: {
            title: "Configuração"
        },
        IconButtonDelete: {
            title: "Excluir"
        },
        IconButtonEdit: {
            title: "Editar"
        },
        IconButtonExcel: {
            title: "Exporta todos os dados da listagem"
        },
        IconButtonExpandMembers: {
            title: "Expandir usuários dos grupos que fazem parte deste grupo"
        },
        IconButtonFilter: {
            title: "Filtrar"
        },
        IconButtonOrderBy: {
            title: "Ordenação"
        },
        IconButtonOverflowV: {
            title: "Mais opções"
        },
        IconButtonOverflowW: {
            title: "Mais opções"
        },
        IconButtonUndelete: {
            title: "Desfazer remoção"
        },
        IconButtonUpload: {
            title: "Carregar arquivo"
        },
        IconButtonCopy: {
            title: "Copiar para área de transferência"
        },
        IconButtonExportExcel: {
            title: "Exportar para Excel"
        },
        IconButtonBlocked: {
            title: "Bloqueado"
        },
        IconButtonGraph: {
            title: "Gráfico"
        },
        IconButtonHierarchy: {
            title: "Hierarquia"
        },
        IconButtonOverflowH: {
            title: "Mais opções"
        },
        IconButtonSave: {
            title: "Salvar Alterações"
        },
        IconButtonSearch: {
            title: "Procurar"
        },
        IconButtonHistory: {
            title: "Histórico"
        },
        IconButtonUndo: {
            title: "Restaurar"
        },
        IconButtonFullScreen: {
            title: "Tela cheia"
        },
        IconButtonRestoreScreen: {
            title: "Sair da tela cheia"
        },
        IconButtonViewDetails: {
            title: "Exibir detalhes"
        },
        IconButtonPreview: {
            title: "Prever"
        },
        IconPublicationThread: {
            title: "Adicionar informações complementares em uma sequência para esta postagem."
        }
    },
    MprcAdvFilter: {
        loadMoreNum: "Carregar mais",
        emptyRecordset: "Não há dados",
        emptyCommands: "Nenhum comando disponível",
        inputPlaceholder: "Procurar...",
        inputPlaceholderFocus: "Digite um texto ou '/' para filtros avançados",
        inputTitleEnterToFilter: "Pressione ENTER para filtrar",
        customPickerDialog: {
            inputPlaceholder: "Procurar..."
        },
        textPickerSearchTypes: {
            equals: "Igual",
            contains: "Contém",
            startWith: "Inicia por"
        },
        textPickerDrawer: {
            title: "Editar filtro",
            searchTextPlaceholder: "Digite um texto"
        },
        textPickerPopper: {
            label: "Procurar",
            placeholder: "procurar..."
        }
    },
    MprcSearchTextField: {
        clearTooltip: "Limpar",
    },
    MprcFilterCount: {
        countTextSingular: "{count} registro encontrado",
        countTextPlural: "{count} registros encontrados",
        filteredTextSingular: "{count} registros filtrado",
        filteredTextPlural: "{count} registros filtrados",
        resetFilterText: "Retirar todos os filtros"
    },
    MprcFilterCountInfo: {
        textSingular: "{count} registro encontrado",
        textPlural: "{count} registros encontrados",
    },
    MprcFilterNoRecords: {
        noRecordsMessage: "No se encontraron registros",
        resetFilterText: "Retirar todos os filtros"
    },
    MprcConfirmation: {
        buttonNoText: "Não",
        buttonYesText: "Sim"
    },
    MprcImageUpload: {
        selectText: "Selecionar"
    },
    MprcAutoComplete: {
        loadMoreText: "Carregar mais",
        alternateMethodTitle: "Método alternativo",
        alreadySelectedText: "Item já selecionado",
        suggestionEmptyListText: "Nenhum item selecionado",
        searchForPlaceholder: "Procurar por...",
        selectedItemsResult: "Selecionados",
        displayingHistory: "Exibindo histórico.",
        exitFromHistory: " para visualização completa."
    },
    MprcAutoComplete2: {
        loadMoreText: "Carregar mais",
        loadingText: "Carregando...",
        noOptionsText: "Não encontrado"
    },
    MprcAutoCompleteHierarchical: {
        loadMoreText: "Carregar mais",
        loadingText: "Carregando...",
        inputPlaceholder: "Pressione ENTER para selecionar",
        lastSelectedText: "Recentemente Selecionados (pressione \\ para listar todos)",
        grouperItemCannotSelected: "Um item agrupador não pode ser selecionado para este campo.",
        itemCannotSelected: "Você não pode ou não tem permissão para selecionar este item.",
        itemAlreadySelected: "Esse item já está selecionado",
        selectSingle: "SELECIONAR APENAS ESTE",
        includeDescendants: "SELECIONAR ESTE E INCLUIR TODOS ABAIXO"
    },
    MprcAutoCompleteFreeText: {
        inputPlaceholder: "Digite um texto e pressione ENTER para confirmar",
    },
    MprcTextFieldNumberMask: {
        invalidValueText: "Valor inválido.",
        minValueText: "Mínimo:",
        maxValueText: "Máximo:",
    },
    MprcKeyboardDatePicker: {
        okText: "Ok",
        cancelText: "Cancelar",
        clearText: "Limpar",
        todayText: "Hoje"
    },
    MprcFileSelection: {
        interrupted: "Operação cancelada pelo usuário",
        uploadError: "Ocorreu um problema ao carregar o arquivo",
        fileNotAccept: "Tipo de arquivo não aceito",
        dropHereText1: "Clique para selecionar ou arraste um arquivo aqui",
        dropHereText2: "ou",
        dropHereText3: "Pressione CTRL+V para colar uma imagem",
        maxSize: "Tamanho máximo",
        maxSizeError: "Tamanho do arquivo excedido"
    },
    MprcImageSelection: {
        selectImageText: "Selecionar",
        interrupted: "Operação cancelada pelo usuário",
        uploadError: "Ocorreu um problema ao carregar o arquivo",
        fileNotAccept: "Tipo de arquivo não aceito",
        fileConversionError: "Não foi possível converter a imagem",
        cloudImageLoadError: "Não foi possível carregar a imagem selecionada.",
        cloudImageNotFound: "Nenhuma imagem encontrada",
        dropHereText1: "Clique para selecionar ou arraste um arquivo aqui",
        dropHereText2: "ou",
        dropHereText3: "Pressione CTRL+V para colar uma imagem",
        searchForLabel: "Procurar...",
        searchImagePlaceholder: "Digite palavras-chave e vamos procurar para você!",
        cropText: "Recortar",
        editTitle: "Ajustar tamanho",
        editCropError: "Ocorreu um erro ao recortar a imagem selecionada.",
        editImageLoadError: "A imagem selecionada não está disponível para download no local de origem. A edição não será possível.",
        editImageFallbackSuccess: "A imagem selecionada não está disponível para download. A imagem miniatura será utilizada para edição.",
        finalSize: "Tamanho Final",
        resizeText: "Redimensionar",
        rotationText: "Rotação",
        originalSize: "Tamanho Original",
    },
    MprcImageSelectionDialog: {
        dialogTitle: "Seleção de Imagem",
        tabLibraryText: "Biblioteca de Imagens",
        tabUploadImageText: "Carregar Imagem",
    },
    MprcAutoSelect: {
        noOptionsText: "Sem opções?"
    },
    MprcConfirmDialog: {
        message: "Confirma?",
        yesText: "Sim",
        noText: "Não",
    },
    MprcDialogConfirm: {
        yesText: "Sim",
        noText: "Não",
    },
    MprcIconButtonMoreOptionsDropdown: {
        title: "Mais opções"
    },
    MprcMultiLanguageInputDialog: {
        title: "Editar em múltiplos idiomas",
        translateButton: "Traduzir",
        errorMessage: "Ops, não foi possível realizar a tradução no momento. Tente novamente."
    },
    MprcPrompt: {
        message: "Você não salvou as mudanças. Descartar alterações?",
        yesText: "Descartar",
        noText: "Cancelar"
    },
    MprcRecordInfo: {
        createdBy: "Criado por",
        changedBy: "Modificado por",
        deletedBy: "Removido por",
        historyText: "Histórico"
    },
    MprcQuillEditor: {
        customField: "Campos",
        publication: "Publicação",
        image: "Imagem",
        video: "Video",
        link: "Hyperlink",
        bold: "Negrito",
        italic: "Itálico",
        underline: "Sublinhado",
        strike: "Cortado",
        identLeft: "Indentação à Esquerda",
        identRight: "Indentação à Direta",
        blockCode: "Bloco de Código",
        blockQuote: "Bloco em Destaque",
        clearFormat: "Limpar formatação",
        fontSize: "Tamanho da Fonte",
        headerSize: "Tamanho do Cabeçaçho",
        textAlign: "Alinhamento do Texto",
        bgColor: "Cor de Fundo",
        textColor: "Cor do Texto",
        orderedList: "Lista Ordenada",
        bulletList: "Lista de marcadores",
        mention: "Adicionar Menção",
        textDirection: "Direção do Texto",
    },
    MprcUserProfileLink: {
        systemName: "Sistema",
        yourselfName: "Você"
    },
    MprcPasteContainer: {
        transformError: "Desculpe, esse não é um formato compatível.",
        pastedError: "Desculpe, mas não há imagem para colar.",
    },
    MprcRibbonList: {
        expandTooltip: "Ver Todos",
        collapseTooltip: "Ver menos",
        slideNextTooltip: "Avançar",
        slidePreviousTooltip: "Voltar",
        seeMoreText: "Ver mais",
        searchPlaceholder: "Procurar na Lista",
        emptyDataText: "Nenhum item encontrado"
    },
    MprcDateTimePicker: {
        endTimeOfDayText: "Final do dia",
        firstTimeOfDayText: "Início do dia"
    },
    MprcTypographyOnDemand: {
        readLess: "Ler menos",
        readMore: "Ler mais"
    },
    MprcTimezoneSelect: {
        mapTooltip: "Selecione o fuso-horário no mapa",
        mapDlgTitle: "Fuso-Horário",
        mapDlgDescription: "Fuso-Horário"
    },
    MprcInfoIconButton: {
        title: "Mais Informações"
    },
    MprcReactPlayer: {
        speedButtomTitle: "Configurações de velocidade",
        closeCaptionTitle: "Configurações de legendas",
        volumeTitle: "Controle de volume",
        mutedOffTitle: "Ativar som",
        muteOnTitle: "Silenciar",
        progressTitle: "Progresso do vídeo",
        pauseTitle: "Pausar",
        playTitle: "Reproduzir",
        fullscreenInTitle: "Exibir em tela cheia",
        fullscreenOutTitle: "Sair da tela cheia"
    }
};

export const enUS: MprcLocaleType = {
    buttons: {
        ButtonAdd: {
            text: "Add"
        },
        ButtonApply: {
            text: "apply"
        },
        ButtonApplyFilter: {
            text: "Add"
        },
        ButtonBack: {
            text: "Back"
        },
        ButtonCancel: {
            text: "Cancel"
        },
        ButtonClose: {
            text: "Close"
        },
        ButtonClear: {
            text: "Clear"
        },
        ButtonConfirm: {
            text: "Confirm"
        },
        ButtonConfirmAndClose: {
            text: "Confirm and Close"
        },
        ButtonContinue: {
            text: "Continue"
        },
        ButtonCopyToClipboard: {
            text: "Copy to Clipboard"
        },
        ButtonDelete: {
            text: "Remove"
        },
        ButtonDiscard: {
            text: "Discard"
        },
        ButtonEdit: {
            text: "Edit"
        },
        ButtonEllipsis: {
            title: "More options"
        },
        ButtonError: {
            text: "Ver errores",
            title: "Ver errores"
        },
        ButtonExport: {
            text: "Export"
        },
        ButtonFinish: {
            text: "Finish"
        },
        ButtonOk: {
            text: "Ok"
        },
        ButtonOrderBy: {
            title: "Order by"
        },
        ButtonOverflowV: {
            title: "More options"
        },
        ButtonPrint: {
            text: "Print"
        },
        ButtonPublish: {
            text: "Publish"
        },
        ButtonSave: {
            text: "Save"
        },
        ButtonSelect: {
            text: "Select",
        },
        ButtonSend: {
            text: "Send",
            title: "Send informations"
        },
        ButtonJoin: {
            text: "Join"
        },
        ButtonResetFilter: {
            text: "Clear Filter"
        },
        ButtonRefresh: {
            text: "Reload"
        },
        ButtonRetry: {
            text: "Retry"
        },
        ButtonNextStep: {
            text: "Next"
        },
        ButtonPreviousStep: {
            text: "Previous"
        }
    },
    iconButtons: {
        IconButtonAdd: {
            title: "Add"
        },
        IconButtonAI: {
            title: "Create with Artificial Intelligence"
        },
        IconButtonBack: {
            title: "Back"
        },
        IconButtonCancel: {
            title: "Cancel"
        },
        IconButtonClearSearch: {
            title: "Clear"
        },
        IconButtonClose: {
            title: "Close"
        },
        IconButtonCog: {
            title: "Setup"
        },
        IconButtonDelete: {
            title: "Remove"
        },
        IconButtonExcel: {
            title: "Export all listing data"
        },
        IconButtonEdit: {
            title: "Edit"
        },
        IconButtonExpandMembers: {
            title: "Expand users from groups that are part of this group"
        },
        IconButtonFilter: {
            title: "Filter"
        },
        IconButtonOrderBy: {
            title: "Order by"
        },
        IconButtonOverflowV: {
            title: "More Options"
        },
        IconButtonOverflowW: {
            title: "More Options"
        },
        IconButtonUndelete: {
            title: "Undelete"
        },
        IconButtonUpload: {
            title: "File Upload"
        },
        IconButtonCopy: {
            title: "Copy to Clipboard"
        },
        IconButtonExportExcel: {
            title: "Export to Excel"
        },
        IconButtonBlocked: {
            title: "Blocked"
        },
        IconButtonGraph: {
            title: "Graphic"
        },
        IconButtonHierarchy: {
            title: "Hierarchy"
        },
        IconButtonOverflowH: {
            title: "More options"
        },
        IconButtonSave: {
            title: "Save Changes"
        },
        IconButtonSearch: {
            title: "Search"
        },
        IconButtonHistory: {
            title: "History"
        },
        IconButtonUndo: {
            title: "Undo"
        },
        IconButtonFullScreen: {
            title: "Full screen"
        },
        IconButtonRestoreScreen: {
            title: "Exit full screen"
        },
        IconButtonViewDetails: {
            title: "View details"
        },
        IconButtonPreview: {
            title: "Preview"
        },
        IconPublicationThread: {
            title: "Add additional information in a thread for this post."
        }
    },
    MprcAdvFilter: {
        loadMoreNum: "Load more",
        emptyRecordset: "There are no data",
        emptyCommands: "There area no commands available",
        inputPlaceholder: "Search...",
        inputPlaceholderFocus: "Type a text or '/' for advanced filters",
        inputTitleEnterToFilter: "Press ENTER to filter",
        customPickerDialog: {
            inputPlaceholder: "Search..."
        },
        textPickerSearchTypes: {
            equals: "Equals",
            contains: "Contains",
            startWith: "Start with"
        },
        textPickerDrawer: {
            title: "Edit Filter",
            searchTextPlaceholder: "Type a text"
        },
        textPickerPopper: {
            label: "Search for",
            placeholder: "Search for..."
        }
    },
    MprcSearchTextField: {
        clearTooltip: "Clear",
    },
    MprcFileSelection: {
        interrupted: "Operation canceled by user",
        uploadError: "There was a problem loading the file",
        fileNotAccept: "Unsupported file type",
        dropHereText1: "Click to select or drag a file here",
        dropHereText2: "or",
        dropHereText3: "Press CTRL+V to paste an image",
        maxSize: "Maximum size",
        maxSizeError: "Exceeded file size"
    },
    MprcFilterCount: {
        countTextSingular: "{count} record found",
        countTextPlural: "{count} records found",
        filteredTextSingular: "{count} record filtered",
        filteredTextPlural: "{count} records filtered",
        resetFilterText: "Remove all filters"
    },
    MprcFilterCountInfo: {
        textSingular: "{count} record found",
        textPlural: "{count} records found",
    },
    MprcFilterNoRecords: {
        noRecordsMessage: "No record found",
        resetFilterText: "Remove all filters"
    },

    MprcConfirmation: {
        buttonNoText: "No",
        buttonYesText: "Yes"
    },
    MprcImageUpload: {
        selectText: "Select"
    },
    MprcAutoComplete: {
        loadMoreText: "Load more",
        alternateMethodTitle: "Alternative method",
        alreadySelectedText: "Item already selected",
        suggestionEmptyListText: "No items selected",
        searchForPlaceholder: "Search for...",
        selectedItemsResult: "selected",
        displayingHistory: "Displaying history. ",
        exitFromHistory: " for full view."
    },
    MprcAutoComplete2: {
        loadMoreText: "Load more",
        loadingText: "Loading...",
        noOptionsText: "Not found"
    },
    MprcAutoCompleteHierarchical: {
        loadMoreText: "Load more",
        loadingText: "Loading...",
        inputPlaceholder: "Press ENTER to select",
        lastSelectedText: "Recently Selected (press \\ to list all)",
        grouperItemCannotSelected: "A grouper item cannot be selected for this field.",
        itemCannotSelected: "You cannot or do not have permission to select this item.",
        itemAlreadySelected: "This item is already selected",
        selectSingle: "SELECT ONLY THIS",
        includeDescendants: "SELECT THIS AND INCLUDE ALL BELOW"
    },
    MprcAutoCompleteFreeText: {
        inputPlaceholder: "Enter text and press ENTER to confirm",
    },
    MprcTextFieldNumberMask: {
        invalidValueText: "Invalid value.",
        minValueText: "Minimum:",
        maxValueText: "Maximum:",
    },
    MprcKeyboardDatePicker: {
        okText: "Ok",
        cancelText: "Cancel",
        clearText: "Clear",
        todayText: "Today"
    },
    MprcImageSelection: {
        selectImageText: "Select",
        interrupted: "Operation canceled by user",
        uploadError: "There was a problem loading the file",
        fileNotAccept: "Unsupported file type",
        fileConversionError: "Could not convert image",
        cloudImageLoadError: "Could not load selected image.",
        cloudImageNotFound: "No image found",
        dropHereText1: "Click to select or drag a file here",
        dropHereText2: "or",
        dropHereText3: "Press CTRL+V to paste an image",
        searchForLabel: "Search...",
        searchImagePlaceholder: "Enter keywords and we'll search for you!",
        cropText: "Crop",
        editTitle: "Adjust size",
        editCropError: "There was an error cropping the selected image.",
        editImageLoadError: "The selected image is not available for download from the source location. Editing will not be possible.",
        editImageFallbackSuccess: "The source image you selected is not available for download. The thumbnail image will be used for editing.",
        finalSize: "Final Size",
        resizeText: "Resize",
        rotationText: "Rotation",
        originalSize: "Original Size",
    },
    MprcImageSelectionDialog: {
        dialogTitle: "Image Selection",
        tabLibraryText: "Image Library",
        tabUploadImageText: "Upload Image",
    },
    MprcAutoSelect: {
        noOptionsText: "No Options?"
    },
    MprcConfirmDialog: {
        message: "Confirm?",
        yesText: "Yes",
        noText: "No",
    },
    MprcDialogConfirm: {
        yesText: "Yes",
        noText: "No",
    },
    MprcIconButtonMoreOptionsDropdown: {
        title: "More Options"
    },
    MprcMultiLanguageInputDialog: {
        title: "Edit in multiple languages",
        translateButton: "Translate",
        errorMessage: "Ops, unable to translate at this time. Please try again."
    },
    MprcPrompt: {
        message: "You have not saved the changes. Discard changes?",
        yesText: "Discard",
        noText: "Cancel"
    },
    MprcRecordInfo: {
        createdBy: "Created by",
        changedBy: "Changed by",
        deletedBy: "Deleted by",
        historyText: "History"
    },
    MprcQuillEditor: {
        customField: "Fields",
        publication: "Publication",
        image: "Image",
        video: "Video",
        link: "Hyperlink",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        strike: "Strike",
        identLeft: "Identify Left",
        identRight: "Identify Right",
        blockCode: "Block Code",
        blockQuote: "Block Quote",
        clearFormat: "Clear Format",
        fontSize: "Font Size",
        headerSize: "Header Size",
        textAlign: "Text Align",
        bgColor: "Background Color",
        textColor: "Text Color",
        orderedList: "Ordered List",
        bulletList: "Bullet List",
        mention: "Add Mention",
        textDirection: "Text Direction",
    },
    MprcUserProfileLink: {
        systemName: "System",
        yourselfName: "You"
    },
    MprcPasteContainer: {
        transformError: "Sorry, that's not a format we support.",
        pastedError: "Sorry, to bother you but there was no image pasted.",
    },
    MprcRibbonList: {
        expandTooltip: "See All",
        collapseTooltip: "See less",
        slideNextTooltip: "Go forward",
        slidePreviousTooltip: "Back",
        seeMoreText: "See More",
        searchPlaceholder: "Search in list",
        emptyDataText: "No items found"
    },
    MprcDateTimePicker: {
        endTimeOfDayText: "End of the day",
        firstTimeOfDayText: "Beggining of day"
    },
    MprcTypographyOnDemand: {
        readLess: "Read less",
        readMore: "Read more"
    },
    MprcTimezoneSelect: {
        mapTooltip: "Select the time zone on the map",
        mapDlgTitle: "Time zone",
        mapDlgDescription: "Time zone"
    },
    MprcInfoIconButton: {
        title: "More information"
    },
    MprcReactPlayer: {
        speedButtomTitle: "Speed Settings",
        closeCaptionTitle: "Subtitle Settings",
        volumeTitle: "Volume Control",
        mutedOffTitle: "Enable sound",
        muteOnTitle: "Mute",
        progressTitle: "Video Progress",
        pauseTitle: "Pause",
        playTitle: "Play",
        fullscreenInTitle: "Enter Fullscreen",
        fullscreenOutTitle: "Exit Fullscreen"
    }
};

export const esES: MprcLocaleType = {
    buttons: {
        ButtonAdd: {
            text: "Agregar"
        },
        ButtonApply: {
            text: "Aplicar"
        },
        ButtonApplyFilter: {
            text: "Agregar"
        },
        ButtonBack: {
            text: "Volver"
        },
        ButtonCancel: {
            text: "Cancelar"
        },
        ButtonClose: {
            text: "Cerrar"
        },
        ButtonClear: {
            text: "Limpiar"
        },
        ButtonConfirm: {
            text: "Confirmar"
        },
        ButtonConfirmAndClose: {
            text: "Confirmar e Cerrar"
        },
        ButtonContinue: {
            text: "Continuar"
        },
        ButtonCopyToClipboard: {
            text: "Copiar al portapapeles"
        },
        ButtonDelete: {
            text: "Eliminar"
        },
        ButtonDiscard: {
            text: "Descartar"
        },
        ButtonEdit: {
            text: "Editar"
        },
        ButtonEllipsis: {
            title: "Mas opciones"
        },
        ButtonError: {
            text: "View Errors",
            title: "View Errors"
        },
        ButtonExport: {
            text: "Exportar"
        },
        ButtonFinish: {
            text: "Finalizar"
        },
        ButtonOk: {
            text: "Ok"
        },
        ButtonOrderBy: {
            title: "Ordenación"
        },
        ButtonOverflowV: {
            title: "Mas opciones"
        },
        ButtonPrint: {
            text: "Imprimir"
        },
        ButtonPublish: {
            text: "Publicar"
        },
        ButtonSave: {
            text: "Guardar"
        },
        ButtonSend: {
            text: "Enviar",
            title: "Enviar Información"
        },
        ButtonSelect: {
            text: "Seleccionar",
        },
        ButtonJoin: {
            text: "Unir"
        },
        ButtonResetFilter: {
            text: "Borrar filtro"
        },
        ButtonRefresh: {
            text: "Recargar"
        },
        ButtonRetry: {
            text: "Intentar Nuevamente"
        },
        ButtonNextStep: {
            text: "Próximo"
        },
        ButtonPreviousStep: {
            text: "Anterior"
        }
    },
    iconButtons: {
        IconButtonAdd: {
            title: "Agregar"
        },
        IconButtonAI: {
            title: "Crear con Inteligencia Artificial"
        },
        IconButtonBack: {
            title: "Volver"
        },
        IconButtonCancel: {
            title: "Cancelar"
        },
        IconButtonClearSearch: {
            title: "Limpiar"
        },
        IconButtonClose: {
            title: "Cerrar"
        },
        IconButtonCog: {
            title: "Configuracion"
        },
        IconButtonDelete: {
            title: "Excluir"
        },
        IconButtonEdit: {
            title: "Eliminar"
        },
        IconButtonExpandMembers: {
            title: "Ampliar usuarios de grupos que forman parte de este grupo"
        },
        IconButtonExcel: {
            title: "Exporta todos los datos de la lista"
        },
        IconButtonFilter: {
            title: "Filtrar"
        },
        IconButtonOrderBy: {
            title: "Ordenación"
        },
        IconButtonOverflowV: {
            title: "Mas opciones"
        },
        IconButtonOverflowW: {
            title: "Mas opciones"
        },
        IconButtonUndelete: {
            title: "Deshacer eliminación"
        },
        IconButtonUpload: {
            title: "Subir archivo"
        },
        IconButtonCopy: {
            title: "Copiar al portapapeles"
        },
        IconButtonExportExcel: {
            title: "Exportar a Excel"
        },
        IconButtonBlocked: {
            title: "Bloqueado"
        },
        IconButtonGraph: {
            title: "Gráfico"
        },
        IconButtonHierarchy: {
            title: "Jerarquía"
        },
        IconButtonOverflowH: {
            title: "Mas opciones"
        },
        IconButtonSave: {
            title: "Guardar Cambios"
        },
        IconButtonSearch: {
            title: "Buscar"
        },
        IconButtonHistory: {
            title: "Histórico"
        },
        IconButtonUndo: {
            title: "Deshacer"
        },
        IconButtonFullScreen: {
            title: "Pantalla completa"
        },
        IconButtonRestoreScreen: {
            title: "Salir de pantalla completa"
        },
        IconButtonViewDetails: {
            title: "Ver detalles"
        },
        IconButtonPreview: {
            title: "Predecir"
        },
        IconPublicationThread: {
            title: "Agregue información adicional en un hilo para esta publicación."
        }
    },
    MprcAdvFilter: {
        loadMoreNum: "Cargar más",
        emptyRecordset: "No hay resultados",
        emptyCommands: "Ningún comando disponible",
        inputPlaceholder: "Buscar...",
        inputPlaceholderFocus: "Escriba texto o '/' para filtros avanzados",
        inputTitleEnterToFilter: "Pressione ENTER para filtrar",
        customPickerDialog: {
            inputPlaceholder: "Buscar..."
        },
        textPickerSearchTypes: {
            equals: "Igual",
            contains: "Contiene",
            startWith: "Empezar con"
        },
        textPickerDrawer: {
            title: "Editar filtro",
            searchTextPlaceholder: "Escriba un texto"
        },
        textPickerPopper: {
            label: "Buscar",
            placeholder: "buscar..."
        }
    },
    MprcSearchTextField: {
        clearTooltip: "Limpiar",
    },
    MprcFilterCount: {
        countTextSingular: "{count} registro encontrado",
        countTextPlural: "{count} registros encontrados",
        filteredTextSingular: "{count} registros filtrado",
        filteredTextPlural: "{count} registros filtrados",
        resetFilterText: "Eliminar todos los filtros"
    },
    MprcFilterCountInfo: {
        textSingular: "{count} registro encontrado",
        textPlural: "{count} registros encontrados",
    },
    MprcFilterNoRecords: {
        noRecordsMessage: "Nenhum registro encontrado",
        resetFilterText: "Eliminar todos los filtros"
    },
    MprcConfirmation: {
        buttonNoText: "No",
        buttonYesText: "Sí"
    },
    MprcImageUpload: {
        selectText: "Seleccionar"
    },
    MprcAutoComplete: {
        loadMoreText: "Cargar más",
        alternateMethodTitle: "Método alternativo",
        alreadySelectedText: "Item ya seleccionado",
        suggestionEmptyListText: "No hay item seleccionados",
        searchForPlaceholder: "Buscar...",
        selectedItemsResult: "Seleccionados",
        displayingHistory: "Visualización de la historia. ",
        exitFromHistory: " para vista completa."

    },
    MprcAutoComplete2: {
        loadMoreText: "Cargar más",
        loadingText: "Cargando...",
        noOptionsText: "No encontrado"
    },
    MprcAutoCompleteHierarchical: {
        loadMoreText: "Cargar más",
        loadingText: "Cargando...",
        inputPlaceholder: "Presione ENTER para seleccionar",
        lastSelectedText: "Seleccionados recientemente (presione \\ para enumerar todos)",
        grouperItemCannotSelected: "No se puede seleccionar un elemento de mero para este campo.",
        itemCannotSelected: "No puedes o no tienes permiso para seleccionar este elemento.",
        itemAlreadySelected: "Este elemento ya está seleccionado",
        selectSingle: "SELECCIONE APENAS ESTE",
        includeDescendants: "SELECCIONE E INCLUYA TODO A CONTINUACIÓN"
    },
    MprcAutoCompleteFreeText: {
        inputPlaceholder: "Ingrese el texto y presione ENTER para confirmar",
    },
    MprcTextFieldNumberMask: {
        invalidValueText: "Valor no válido.",
        minValueText: "Mínimo:",
        maxValueText: "Máximo:",
    },
    MprcKeyboardDatePicker: {
        okText: "Ok",
        cancelText: "Cancelar",
        clearText: "Limpiar",
        todayText: "Hoy"
    },
    MprcFileSelection: {
        interrupted: "Operación cancelada por el usuario",
        uploadError: "Hubo un problema al cargar el archivo",
        fileNotAccept: "Tipo de archivo no aceptado",
        dropHereText1: "Haga clic para seleccionar o arrastre un archivo aquí",
        dropHereText2: "o",
        dropHereText3: "Presione CTRL+V para pegar una imagen",
        maxSize: "Tamaño máximo",
        maxSizeError: "Tamaño de archivo excedido"
    },
    MprcImageSelection: {
        selectImageText: "Seleccionar",
        interrupted: "Operación cancelada por el usuario",
        uploadError: "Hubo un problema al cargar el archivo",
        fileNotAccept: "Tipo de archivo no aceptado",
        fileConversionError: "No se pudo convertir la imagen",
        cloudImageLoadError: "No se pudo cargar la imagen seleccionada.",
        cloudImageNotFound: "Ninguna imagen encontrada",
        dropHereText1: "Haga clic para seleccionar o arrastre un archivo aquí",
        dropHereText2: "o",
        dropHereText3: "Presione CTRL+V para pegar una imagen",
        searchForLabel: "Buscar...",
        searchImagePlaceholder: "¡Ingrese palabras clave y lo buscaremos!",
        cropText: "Cosecha",
        editTitle: "Ajustar el tamaño",
        editCropError: "Hubo un error al recortar la imagen seleccionada.",
        editImageLoadError: "La imagen seleccionada no está disponible para descargar desde la ubicación de origen. No será posible editarla.",
        editImageFallbackSuccess: "La imagen que seleccionaste no está disponible para descargar. La miniatura se usará para editarla.",
        finalSize: "Tamaño final",
        resizeText: "Redimensionar",
        rotationText: "Rotación",
        originalSize: "Tamaño original",
    },
    MprcImageSelectionDialog: {
        dialogTitle: "Selección de imagen",
        tabLibraryText: "Biblioteca de Imágenes",
        tabUploadImageText: "Subir imagen",
    },
    MprcAutoSelect: {
        noOptionsText: "¿Sin opciones?"
    },
    MprcConfirmDialog: {
        message: "Confirma?",
        yesText: "Sí",
        noText: "No",
    },
    MprcDialogConfirm: {
        yesText: "Sí",
        noText: "No",
    },
    MprcIconButtonMoreOptionsDropdown: {
        title: "Mas opciones"
    },
    MprcMultiLanguageInputDialog: {
        title: "Editar en varios idiomas",
        translateButton: "Traduzir",
        errorMessage: "Ups, no se puede traducir en este momento. Inténtalo de nuevo."
    },
    MprcPrompt: {
        message: "No has guardado los cambios. ¿Descartar cambios?",
        yesText: "Descartar",
        noText: "Cancelar"
    },
    MprcRecordInfo: {
        createdBy: "Criado por",
        changedBy: "Modificado por",
        deletedBy: "Eliminado por",
        historyText: "Histórico"
    },
    MprcQuillEditor: {
        customField: "Campos",
        publication: "Publicación",
        image: "Imagen",
        video: "Video",
        link: "Hipervínculo",
        bold: "Negrita",
        italic: "Itálico",
        underline: "Subrayar",
        strike: "Cortado",
        identLeft: "Identificación izquierda",
        identRight: "identificación directa",
        blockCode: "Bloque de código",
        blockQuote: "Bloque destacado",
        clearFormat: "Eliminar formato",
        fontSize: "Tamaño de fuente",
        headerSize: "Tamaño del encabezado",
        textAlign: "Alineación del texto",
        bgColor: "Color de fondo",
        textColor: "Color de texto",
        orderedList: "Lista Ordenada",
        bulletList: "Lista de viñetas",
        mention: "Añadir Mención",
        textDirection: "Dirección del texto",
    },
    MprcUserProfileLink: {
        systemName: "Sistema",
        yourselfName: "Usted"
    },
    MprcPasteContainer: {
        transformError: "Lo sentimos, ese no es un formato compatible.",
        pastedError: "Lo siento, pero no hay imagen para pegar.",
    },
    MprcRibbonList: {
        expandTooltip: "Ver Todos",
        collapseTooltip: "Ver menos",
        slideNextTooltip: "Avance",
        slidePreviousTooltip: "Volver",
        seeMoreText: "Ver más",
        searchPlaceholder: "Procurar en la Lista",
        emptyDataText: "No se encontraron artículos"
    },
    MprcDateTimePicker: {
        endTimeOfDayText: "Final del día",
        firstTimeOfDayText: "Comienzo del dia"
    },
    MprcTypographyOnDemand: {
        readLess: "Leer menos",
        readMore: "Leer más"
    },
    MprcTimezoneSelect: {
        mapTooltip: "Seleccione la zona horaria en el mapa",
        mapDlgTitle: "Huso horario",
        mapDlgDescription: "Huso horario",
    },
    MprcInfoIconButton: {
        title: "Más información"
    },
    MprcReactPlayer: {
        speedButtomTitle: "Ajustes de velocidad",
        closeCaptionTitle: "Configuración de subtítulos",
        volumeTitle: "Control de volumen",
        mutedOffTitle: "Habilitar sonido",
        muteOnTitle: "Silenciar",
        progressTitle: "Progreso del vídeo",
        pauseTitle: "Pausa",
        playTitle: "Jugar",
        fullscreenInTitle: "Mostrar en pantalla completa",
        fullscreenOutTitle: "Salir de pantalla completa"
    }
};
